import React, {Component, useState} from 'react';
import {useMatches} from '@remix-run/react';
import clsx from 'clsx';
import {useEffect} from 'react';
import {CartDrawer, useDrawer} from '~/components/cart/CartDrawer';
import CartToggle from '~/components/cart/CartToggle';
import {CountrySelector} from '~/components/global/CountrySelector';
import {UserIcon} from '~/components/icons/User';
import {Link} from '~/components/Link';
import {useCartFetchers} from '~/hooks/useCartFetchers';
import AlgoliaSearch from './AlgoliaSearch';

export default function HeaderActions() {
  const [showSearch, setShowSearch] = useState(false);

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const {isOpen, openDrawer, closeDrawer} = useDrawer();
  const [root] = useMatches();
  const cart = root.data?.cart;

  // Grab all the fetchers that are adding to cart
  const addToCartFetchers = useCartFetchers('ADD_TO_CART');

  // When the fetchers array changes, open the drawer if there is an add to cart action
  useEffect(() => {
    if (
      isOpen ||
      addToCartFetchers.length === 0 ||
      addToCartFetchers[0].state === 'submitting'
    )
      return;
    openDrawer();
  }, [addToCartFetchers, isOpen, openDrawer]);

  let searchTarget = '/pages/search';

  return (
    <>
      <div
        className={clsx(
          'absolute right-0 top-0 flex h-full items-center', //
          'md:top-3 md:mr-4',
        )}
      >
        <Link to={searchTarget}>
          <div className="p-0" onClick={() => toggleSearch()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              />
            </svg>
          </div>
        </Link>

        {/* Country select */}
        <div
          className={clsx(
            'hidden', //
            'lg:block',
          )}
        >
          <CountrySelector />
        </div>
        {/* Account */}
        <Link
          className={clsx([
            'hidden h-[2.4rem] items-center rounded-sm bg-darkGray bg-opacity-0 p-2',
            'lg:flex',
            'hover:bg-opacity-10',
          ])}
          to="/account"
        >
          <UserIcon />
        </Link>
        {/* Cart */}
        <div className="ml-2 mr-4 flex h-full items-center justify-center py-4">
          <CartToggle cart={cart} isOpen openDrawer={openDrawer} />
        </div>
      </div>

      <CartDrawer cart={cart} open={isOpen} onClose={closeDrawer} />

      {/*
 {showSearch === true ? <AlgoliaSearch onClose={toggleSearch} /> : <></>}
  */}
    </>
  );
}
